import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginPageComponent} from './pages/login-page/login-page.component';
import {FormsModule} from '@angular/forms';
import {RippleModule} from 'primeng/ripple';
import { TenantSelectionPageComponent } from './pages/tenant-selection-page/tenant-selection-page.component';
import {AppCommonModule} from '../app-common/app-common.module';
import {ButtonModule} from 'primeng/button';
import {RouterModule} from '@angular/router';
import {InputTextModule} from 'primeng/inputtext';
import {RegisterTrialPageComponent} from './pages/register-trial-page/register-trial-page.component';
import {ForgotPasswordPageComponent} from './pages/forgot-password-page/forgot-password-page.component';
import {DialogModule} from 'primeng/dialog';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {
  CreateOrganizationFormComponent
} from './components/create-organization-form/create-organization-form.component';
import { ForceUpdateScreenComponent } from './components/force-update-screen/force-update-screen.component';


@NgModule({
  declarations: [
    LoginPageComponent,
    RegisterTrialPageComponent,
    ForgotPasswordPageComponent,
    TenantSelectionPageComponent,
    CreateOrganizationFormComponent,
    ForceUpdateScreenComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RippleModule,
    AppCommonModule,
    ButtonModule,
    RouterModule,
    InputTextModule,
    DialogModule,
    ProgressSpinnerModule,
  ],
  exports: [
    LoginPageComponent,
    RegisterTrialPageComponent,
    ForgotPasswordPageComponent,
    TenantSelectionPageComponent,
    CreateOrganizationFormComponent,
    ForceUpdateScreenComponent,
  ]
})
export class AuthModule {
}
